import { fetchPrivacyPolicy, fetchTermsAndConditions } from './action'
import { createSlice } from '@reduxjs/toolkit'
import { HYDRATE } from 'next-redux-wrapper'

interface AgreementsState {
  termsAndConditions: PlainInfo<string>
  privacyPolicy: PlainInfo<string>
}

type PlainInfo<T> = {
  status: RequestState
  error?: string
  data: T
}

type RequestState = 'pending' | 'fulfilled' | 'rejected' | 'none'

const initialState: AgreementsState = {
  termsAndConditions: {
    status: 'none',
    data: ''
  },
  privacyPolicy: {
    status: 'none',
    data: ''
  }
}

export const agreementSlice = createSlice({
  name: '@agreements',
  initialState,
  reducers: {},
  extraReducers: (builder) =>
    builder
      .addCase(fetchTermsAndConditions.pending, (state) => {
        state.termsAndConditions.status = 'pending'
      })
      .addCase(fetchTermsAndConditions.fulfilled, (state, action) => {
        state.termsAndConditions.status = 'fulfilled'
        state.termsAndConditions.data = action.payload.data
      })
      .addCase(fetchTermsAndConditions.rejected, (state, action) => {
        state.termsAndConditions.status = 'rejected'
        state.termsAndConditions.error = action.error.message
      })
      .addCase(fetchPrivacyPolicy.pending, (state) => {
        state.privacyPolicy.status = 'pending'
      })
      .addCase(fetchPrivacyPolicy.fulfilled, (state, action) => {
        state.privacyPolicy.status = 'fulfilled'
        state.privacyPolicy.data = action.payload.data
      })
      .addCase(fetchPrivacyPolicy.rejected, (state, action) => {
        state.privacyPolicy.status = 'rejected'
        state.privacyPolicy.error = action.error.message
      })
      .addCase(HYDRATE, (state, action) => ({
        ...state,
        ...action['payload']['@agreements'],
      }))
})
